/**
 * MED-TAC Collection Page Consolidated Script
 * Project: Priority 2 Collection Performance Consolidation
 * Consolidates deferred collection DOM helpers
 */
(function() {
  'use strict';

  function hideListStyleDuplicates() {
    var listStyleElements = document.querySelectorAll('.product-list-style');
    for (var i = 0; i < listStyleElements.length; i++) {
      listStyleElements[i].style.display = 'none';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideListStyleDuplicates);
  } else {
    hideListStyleDuplicates();
  }

  window.addEventListener('load', hideListStyleDuplicates);
  document.addEventListener('shopify:section:load', hideListStyleDuplicates);
  document.addEventListener('collection:reloaded', hideListStyleDuplicates);
  document.addEventListener('facet:updated', hideListStyleDuplicates);
})();
